import type { Group } from '../types';

export const toCustomFieldValue = (value: Group | null): string | null =>
	value == null ? null : value.name;
